module.exports = __webpack_public_path__ + "img/member-banner.3d63aab3.png";